import { Loader2 } from 'lucide-react';

export function PageLoader({ label = 'Загрузка…' }: { label?: string }) {
  return (
    <div className="flex min-h-[50vh] w-full flex-col items-center justify-center gap-3">
      <Loader2 className="h-8 w-8 animate-spin text-brand-primary" />
      <p className="text-sm text-text-muted">{label}</p>
    </div>
  );
}

export function InlineSpinner({ label }: { label?: string }) {
  return (
    <span className="inline-flex items-center gap-2 text-text-muted">
      <Loader2 className="h-4 w-4 animate-spin text-brand-primary" />
      {label}
    </span>
  );
}
